import * as React from "react";
import { setWeekday } from "../utils";
import "../CronPicker.scss";
import { Everyday } from "../../../entities";
import { Classes } from "../../externals";
export class DayNumDaySelector extends React.PureComponent {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement("div", null,
            React.createElement("div", { className: `${Classes.SELECT} option-item` },
                React.createElement("select", { disabled: this.props.disabled, onChange: (e) => this.props.onChange(setWeekday("#" + e.target.value.toString(), this.props.currentWeekday)) },
                    React.createElement("option", { value: 1, label: "First" }),
                    React.createElement("option", { value: 2, label: "Second" }),
                    React.createElement("option", { value: 3, label: "Third" }),
                    React.createElement("option", { value: 4, label: "Fourth" }))),
            React.createElement("div", { className: `${Classes.SELECT} option-item` },
                React.createElement("select", { disabled: this.props.disabled, onChange: (e) => this.props.onChange(setWeekday(e.target.value.toString().substring(0, 3), this.props.currentWeekday)) }, Object.keys(Everyday).map((value, index) => (React.createElement("option", { key: `${value}_${index}`, value: value, label: Everyday[value] })))))));
    }
}
//# sourceMappingURL=DayNumDaySelector.js.map